<template>
	<header>
		<div class="header-logo">
			<div class="header-logonav">
				<div class="top-logo">
					<img src="../../static/img/logo2.png"/>
				</div>
				<!--
				<div class="top-other">
					<span><p>设为主页   &nbsp;&nbsp;|&nbsp;&nbsp;  收藏本页</p></span>
					<span>
						<a rel="nofollow" title=" 客服热线：0752-2123600" target="_blank"><img src="../../static/img/icon1.png"/></a>
						<a rel="nofollow" href="http://wpa.qq.com/msgrd?v=3&uin=3250932395&site=qq&menu=yes" title="QQ：3250932395" target="_blank"><img src="../../static/img/icon2.png"/></a>
						<img src="../../static/img/log-sys.png"/>
						<a href="http://oa.gd-sc.net:8080/obpm/">进入业务系统</a></span>
				</div>
				<!-->
				<div class="nav-nav">
					<ul>
						<li v-for="(na , index) in nav" v-bind:class="{liactive: acli == na.id}"  id="index" @mouseenter="slide(index)" @mouseleave="out()" >
							<div class="gogogo"  @click="linkto(na.id)">
								<router-link :to= 'na.linkto'  :style="{color : '#333' }" v-bind:class="{liaactive: acli == na.id} "> 
								{{na.name}}
								</router-link>
							</div>
							<!--
							<transition name="slide-fade">
								<ul v-show="judge == na.id">
									<li v-for="con in navcontent[index].content" @click="linkto(na.id)">
										<router-link :to= 'con.vuelink'>
											{{con.name}}
										</router-link>
									</li>
								</ul>
							</transition>
							-->
						</li>
					</ul>
				</div>	
			</div>
		</div>
		<!--<div class="header-nav">
			<div class="nav-logo">
				<img :src="logo"/>
			</div>
			<div class="nav-none">
				
			</div>
			
			<div class="nav-sys">
				<div class="sys-zone">
					<a href="http://oa.gd-sc.net:8080/obpm/">
					<span>
						<img src="../../static/img/user-enter.png"/>业务系统入口
					</span>
					</a>
				</div>
			</div>
		</div>-->
	</header>
</template>
<script>
	export default{
		name: 'header',
		data (){
			return {
					nav : [
					{id : 0, name : '首页' , linkto : '/'},
					{id : 1, name : '公司简介' , linkto : '/About/'},
					{id : 2, name : '企业形象' , linkto : '/Culture/'},
					{id : 3, name : '工程案例' , linkto : '/Engineering/'},
					{id : 4, name : '服务承诺' , linkto : '/Service/'},
					{id : 5, name : '招贤纳士' , linkto : '/Recruit/'},
					{id : 6, name : '留言反馈' , linkto : '/Feedback/'},
					{id : 7, name : '联系我们' , linkto : '/Contact/'},
					],
					judge : -1,
					width : '100%',
					liwidth :'100%',
					logo : 'static/img/logo.png',
					backg : '#fff',
					color : '#fff',
					acli : 0 ,
					op : .1
			}
		},
		mounted(){
			this.getscro();
		},
		methods : {
			slide(index){
				if(index == 0 || index == 4){
					this.judge = -1
				}else{
					this.judge = index
					if(index == 1){
						this.width = '500%'
						this.liwidth = '20%'
					}else if(index == 2){
						this.width = '200%'
						this.liwidth = '50%'
					}else if(index == 3 || index == 5){
						this.width = '400%'
						this.liwidth = '25%'
					}else if(index == 6){
						this.width = '300%'
						this.liwidth = '33.3%'
					}
				}
			},
			out(){
				this.judge = -1
			},
			linkto(index){
				this.acli = index
				this.gotop()
			},
			gotop(){
				window.scrollTo(0,0)
			},
			getscro(){
				var that = this;
				$(document).scroll(function(){
            		var top = $(document).scrollTop();
            		if(top>150){
            			that.logo = 'static/img/logoit.png'
            			that.backg = '#0066ef'
            			that.color = '#fff'
            			that.op = 1
            		}else if(top == 0){
            			that.logo = 'static/img/logo.png'
            			that.backg = '#fff'
            			that.color = '#fff'
            			that.op = .1
            		}else if(top > 15 & top <= 150){
            			that.op = 1
            			that.logo = 'static/img/logo.png'
            			that.color = '#000'
            			that.backg = '#fff'
            		}
            	});
			},
		},
	}
</script>

<style>
	header{
		clear: both;
		width: 100%;
		margin: 0 auto;
		z-index: 20;
		top: 0;
		left: 0;
		position: relative;
	}
	.top-logo{
	    float: left;
	}
	.top-other{
		position: absolute;
	    width: 60%;
	    display: inline-block;
	    clear: both;
	    float: right;
	    text-align: right;
	    top: 1.3vw;
	    right: 9%;
	}
	.top-other img{
		position: relative;
		margin-right: 15px;
	}
	.top-logo img{
		position: relative;
		min-height: 45px;
		top: 1.5vw;
		
	}
	.header-logo{
		position: relative;
		width: 1080px;
		height: 100px;
		background-color: #fff;
		margin: 0 auto;
	}
	.header-nav{
		position: relative;
		width: 100%;
		padding: 8px 0;
		margin: 0 auto;
		clear: both;
		height: 100px;
	}
	.nav-nav{
		margin: 0 auto;
		text-align: center;
		height: 100px;
		float: right;
	}
	.nav-nav li{
		list-style: none;
		padding-left: 15px;
		padding-right: 15px;
		display: inline-block;
		color: #333;
		font-size: 14px;
		z-index: 20;
		vertical-align: text-top;
		height: 100px;
		line-height: 100px;
		transition: all .5s
	}
	.nav-nav li a{
		text-decoration: none;
		color: #333;
	}
	.nav-nav li:hover{
		background: #da251c;
		color: #FFF !important;
	}
	.nav-nav li:hover>.gogogo a{
		color: #FFF !important;
	}
	.nav-nav li.liactive{
		background: #da251c;
		color: #FFF !important;
	}
	.nav-nav li a.liaactive{
		color: #FFF !important;
	}
	.nav-nav ul{
	    -webkit-margin-before: 0em;
	    -webkit-margin-after: 0em;
	    -webkit-margin-start: 0px;
	    -webkit-margin-end: 0px;
	    -webkit-padding-start: 0px;
	    -moz-margin-start: 0;
	    -moz-margin-end: 0;
	}
	.nav-sys{
		width: 10%;
		position: relative;
		display: inline-block;
	}
	.slide-fade-enter-active {
	  transition: all .0s ease;
	}
	.slide-fade-leave-active {
	  transition: all .01s cubic-bezier(1.0, 0.5, 0.8, 1.0);
	}
	.slide-fade-enter, .slide-fade-leave-to
	/* .slide-fade-leave-active for below version 2.1.8 */ {
	  transform: translateX(10px);
	  opacity: 0;
	}
	.header-logonav{
		position: relative;
		margin: 0 auto;
	}
</style>




// WEBPACK FOOTER //
// src/components/header.vue